import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const BoxContainer = styled.div`
	display: flex;
	width: 100%;

	@media ${Breakpoints.tablet} {
		flex-direction: column;
	}
`;

export const FlexContainer = styled.div`
	display: flex;
	flex: 1;
	flex-direction: row;
	@media ${Breakpoints.tablet} {
		flex-direction: column;
	}
`;

export const BoxSizeContainer = styled.div`
	display: flex;
	flex: 1;
	flex-direction: row;
	flex-wrap: wrap;
`;

export const ButtonContainer = styled.div`
	display: flex;
	align-items: flex-start;
	justify-content: flex-end;
	flex: 0 0 50px;
	padding: var(--padding-2) var(--padding-1);
	${({ isFirst }) => isFirst && 'padding-top: 3.6rem;'}

	> button {
		&.outline {
			border-color: var(--red);
			color: var(--red);

			:not(.disabled):hover {
				background: var(--red);
				color: var(--white);

				.button-text,
				.button-icon {
					color: var(--alwaysWhiteColor);
				}
			}

			.button-text,
			.button-icon {
				color: var(--red);
			}
		}

		> .button-text {
			display: none;
		}
	}

	@media ${Breakpoints.tablet} {
		flex-direction: column;
		align-items: flex-start;
		padding: 1rem 1rem 0 1rem;

		> button > .button-text {
			display: block;
		}
	}

	@media ${Breakpoints.mobile} {
		padding: 1rem 1rem 0 1rem;
	}

	body[dir='rtl'] & {
		${({ isFirst }) => isFirst && 'padding-top: 4.6rem;'}
	}
`;
